module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"device":"Device","similarity":"Similarity","startPlaceholder":"Start","endPlaceholder":"End","errMsg":"No Human Face Is Detected"},"zh":{"device":"设备","similarity":"相似度","startPlaceholder":"开始时间","endPlaceholder":"结束时间","errMsg":"未检测到人脸人体"}}')
  delete Component.options._Ctor
}
